export const FEATURE_USAGE_TASKS: Array<FeatureUsageTaskConfig> = [
  {
    name: 'ADD_JOB',
    title: 'Add a job',
    details: 'https://help.teamengine.io/article/43-how-to-add-a-job',
    dependentOn: null,
  },
  {
    name: 'ACTIVATE_JOB',
    title: 'Turn on a job',
    details: 'https://help.teamengine.io/article/43-how-to-add-a-job',
    dependentOn: 'ADD_JOB',
  },
  {
    name: 'REVIEW_APPLICANT',
    title: 'Review an applicant',
    details: 'https://help.teamengine.io/article/37-reviewing-applicants',
    dependentOn: 'ACTIVATE_JOB',
  },
  {
    name: 'ADD_EMPLOYEES',
    title: 'Add 10 or more employees',
    details: 'https://help.teamengine.io/article/44-set-up-your-employee-directory',
    dependentOn: null,
  },
  {
    name: 'CONNECT_CAREER_PAGE',
    title: 'Connect Team Engine jobs to your website',
    details: 'https://help.teamengine.io/article/66-adding-team-engine-jobs-to-your-website',
    dependentOn: null,
  },
  {
    name: 'SEND_EMPLOYEE_MESSAGE',
    title: 'Send an employee message or announcement',
    details: 'https://help.teamengine.io/article/40-overview-of-employee-messaging',
    dependentOn: 'ADD_EMPLOYEES',
  },
  {
    name: 'SEND_EMPLOYEE_SURVEY',
    title: 'Send an employee survey',
    details: 'https://help.teamengine.io/article/45-employee-surveys',
    dependentOn: 'ADD_EMPLOYEES',
  },
];
